{
  "AllNotifications": "All notifications",
  "NoLinkNotification": "No link available for this notification",
  "ViewAllAnnouncementTab": "Announcements",
  "ViewallNotificationTab": "Notifications",
  "preferences": "Edit preferences"
} 
